// extracted by mini-css-extract-plugin
export default {"Items":"Items_QnqUf","title":"title_3Z1CC"};